//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useCallback,
  useEffect,
  Fragment,
  useContext,
} from "react";
import * as moment from "moment";
import { toast } from "react-toastify";
import { PDFDownloadLink } from "@react-pdf/renderer";

// custom pages
import { styles } from "./styles";
import report from "apis/Report/Report";
import MemberRewardsActivityXLSX from "./MemberRewardsActivityXLSX";
import MemberRewardsActivityPDF from "./MemberRewardsActivityPDF";
import Context from "context/context";
import useDebounce from "helpers/useDebounce";

// material-ui
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from "@material-ui/lab/Autocomplete";

// material-ui icons
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useTranslation } from 'react-i18next';
import { enUS, fr } from "date-fns/locale";
export default function MemberLevelReward(props) {
  const { state, dispatch } = useContext(Context);
  const { page, setDisableDropdown } = props;
  const { searchLoyaltyAPI, memberRewardsAPI } = report();
  const classes = styles();
  const { t, i18n } = useTranslation()
  const [states, setstates] = useState({
    columns: [],
    dialog: false,
    data: [],
    excelData: {},
    pdfData: {},
    response: false,
    startDate: new Date(),
    endDate: new Date(),
    dateApplied: false,
    type: "All",
    eLoading: false,
    searchValue: "",
    searchData: [],
    searchLoading: false,
    loyaltyAccount: [],
    excelBtnActive: false,
    pdfBtnActive: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const {
    searchLoading,
    searchData,
    searchValue,
    loyaltyAccount,
    excelBtnActive,
    pdfBtnActive,
  } = states;

  const searchValueDebounce = useDebounce(searchValue);

  // handling search api call
  useEffect(() => {
    if (searchValueDebounce && searchValueDebounce.length > 0) {
      handleSearch();
    }
  }, [searchValueDebounce]);

  // handleSearch api func
  const handleSearch = async () => {
    setStates({ searchLoading: true });
    try {
      let values;
      values = {
        loyaltyId: searchValue,
      };

      let res = await searchLoyaltyAPI(values);
      if (res) {
        setStates({ searchData: res?.data, searchLoading: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // CustomerStatus api func
  const handleGetCustomerStatus = async (type) => {
    try {
      setDisableDropdown(true);
      let values = {};
      values = {
        startDate: moment(states.startDate).format("MM/DD/YYYY"),
        endDate: moment(states.endDate).format("MM/DD/YYYY"),
        loyaltyId: loyaltyAccount?.loyalty_id,
      };

      let res = await memberRewardsAPI(values);
      //console.log({ d: res.data });
      if (res && res.data) {
        dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
        if (type === "excel") {
          setStates({
            excelData: res?.data,
            response: true,
            eLoading: false,
          });
        } else if (type === "pdf") {
          setStates({
            pdfData: res?.data,
            response: true,
            eLoading: false,
          });
        }
        setDisableDropdown(false);
        return true;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const locale = i18n.language == 'fr' ? fr : enUS;

  return (
    <div>
      <div className={classes.headText}>{t('Select Member Account')}</div>
      <div className={classes.inputsDiv}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={3}>
            <Autocomplete
              options={searchData}
              getOptionLabel={(obj) => obj?.loyalty_id || ""}
              value={loyaltyAccount || []}
              className={classes.dateInput}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label={t("Member ID")}
                  margin="none"
                  value={searchValue}
                  onChange={(e) => {
                    if (pdfBtnActive) {
                      setStates({
                        searchValue: e.target.value,
                        pdfBtnActive: false,
                      });
                    }
                    setStates({ searchValue: e.target.value });
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {searchLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
              onChange={(value, obj, reason) => {
                if (reason === "clear") {
                  setStates({ searchValue: "", loyaltyAccount: [] });
                  return;
                }
                if (obj) {
                  setStates({
                    loyaltyAccount: obj,
                    searchValue: obj.value,
                  });
                }
              }}
            />
          </Grid>
        </Grid>
      </div>
      <div className={classes.headText}>
        {t('Select date range')}{" "}
        {states.dateApplied && (
          <React.Fragment>
            <span className={classes.appliedSpan}>
              <CheckCircleIcon />
            </span>
            <span
              className={classes.removeSpan}
              onClick={() => {
                if (pdfBtnActive) {
                  setStates({
                    pdfBtnActive: false,
                    dateApplied: false,
                    startDate: new Date(),
                    endDate: new Date(),
                  });
                }
                setStates({
                  dateApplied: false,
                  startDate: new Date(),
                  endDate: new Date(),
                });
              }}
            >
              {t('Remove')}
            </span>
          </React.Fragment>
        )}
      </div>
      <div className={classes.inputsDiv}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("Start Date")}
                id="date-picker-inline"
                className={classes.dateInput}
                value={states.startDate}
                maxDate={new Date()}
                onChange={(date) => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                    });
                  }
                  if (
                    moment(moment(date).format("MM/DD/YYYY")).isAfter(
                      moment(states.endDate).format("MM/DD/YYYY")
                    )
                  ) {
                    toast.error("Start date should be greater than End date.", {
                      toastId: "start-date-end-date",
                    });
                    setStates({ startDate: null });
                    return;
                  }
                  setStates({ startDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                margin="normal"
                label={t("End Date")}
                id="date-picker-inline2"
                className={classes.dateInput}
                value={states.endDate}
                maxDate={new Date()}
                onChange={(date) => {
                  if (pdfBtnActive) {
                    setStates({
                      pdfBtnActive: false,
                    });
                  }
                  if (
                    moment(moment(date).format("MM/DD/YYYY")).isBefore(
                      moment(states.startDate).format("MM/DD/YYYY")
                    )
                  ) {
                    toast.error("End date should be greater than Start date.", {
                      toastId: "start-date-end-date",
                    });
                    setStates({ endDate: null });
                    return;
                  } else if (
                    moment(moment(date).format("MM/DD/YYYY")).isAfter(
                      moment(new Date()).format("MM/DD/YYYY")
                    )
                  ) {
                    setStates({ endDate: null });
                    toast.error("End date should be lesser that future date.", {
                      toastId: "start-date-end-date",
                    });
                    return;
                  }
                  setStates({ endDate: date, dateApplied: true });
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </div>

      <div className={classes.exportAndPreview}>
        <Button
          className={classes.exportBtn}
          onClick={async () => {
            if (!loyaltyAccount?.loyalty_id) {
              toast.error("Please select the Member Account", {
                toastId: "loyalty-empty",
              });
              return;
            }
            if (
              (states.startDate && !states.endDate) ||
              (!states.startDate && states.endDate) ||
              (!states.startDate && !states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
            if (
              states.startDate?.toString() === "Invalid Date" &&
              states.endDate?.toString() === "Invalid Date"
            ) {
              toast.error("Invalid date.", {
                toastId: "invalid-date",
              });
              setStates({ startDate: new Date(), endDate: new Date() });
              return;
            } else if (states.startDate?.toString() === "Invalid Date") {
              toast.error("Invalid start date.", {
                toastId: "invalid-s-date",
              });
              setStates({ startDate: new Date() });
              return;
            } else if (states.endDate?.toString() === "Invalid Date") {
              toast.error("Invalid end date.", {
                toastId: "invalid-e-date",
              });
              setStates({ endDate: new Date() });
              return;
            }

            setStates({
              response: false,
              excelData: [],
              eLoading: true,
              excelBtnActive: true,
              pdfBtnActive: false,
            });
            let res = await handleGetCustomerStatus("excel");
            // console.log(res,"resss")
            if (res) {
              // console.log(res,"insideif")
              document.getElementById("csv").click();
            }
          }}
          disabled={states.eLoading}
        >
          {/* {states.eLoading && states?.excelBtnActive ? (
            <Fragment>
              <CircularProgress
                style={{ height: 25, width: 25, color: "#fff" }}
                variant="determinate"
                value={state.reportResCount}
              />
              &nbsp;
              <span style={{ color: "#fff", fontWeight: "bold" }}>
                {state.reportResCount}%
              </span>
            </Fragment>
          ) : (
            "Export as Excel"
          )} */}
          {states.eLoading && states.excelBtnActive ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25 }}
                variant="determinate"
                value={state.reportResCount}
              />{" "}
              &nbsp;
              <span style={{ color: "#305698", fontWeight: "bold" }}>
                {state.reportResCount == 0 ? (
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-e"></div>
                    </div>
                  </div>
                ) : (
                  `${state.reportResCount}%`
                )}
              </span>
            </React.Fragment>
          ) : (
            t("Export as excel")
          )}
        </Button>
        <MemberRewardsActivityXLSX
          states={states}
          date={
            moment(moment(states?.startDate).format("MM/DD/YYYY")).isSame(
              moment(states?.endDate).format("MM/DD/YYYY")
            )
              ? `Date : ${moment(states?.startDate).format("MM/DD/YYYY")}`
              : `Date : ${moment(states?.startDate).format(
                "MM/DD/YYYY"
              )} to ${moment(states?.endDate).format("MM/DD/YYYY")}`
          }
          page={page}
        />
        <Button
          className={classes.exportBtn}
          onClick={async () => {
            if (!loyaltyAccount?.loyalty_id) {
              toast.error("Please select the Member Account", {
                toastId: "loyalty-empty",
              });
              return;
            }
            if (
              (states.startDate && !states.endDate) ||
              (!states.startDate && states.endDate) ||
              (!states.startDate && !states.endDate)
            ) {
              toast.error(
                "Please select the both Start-date and End-date values",
                {
                  toastId: "empty-fields",
                }
              );
              return;
            }
            if (
              states.startDate?.toString() === "Invalid Date" &&
              states.endDate?.toString() === "Invalid Date"
            ) {
              toast.error("Invalid date.", {
                toastId: "invalid-date",
              });
              setStates({ startDate: new Date(), endDate: new Date() });
              return;
            } else if (states.startDate?.toString() === "Invalid Date") {
              toast.error("Invalid start date.", {
                toastId: "invalid-s-date",
              });
              setStates({ startDate: new Date() });
              return;
            } else if (states.endDate?.toString() === "Invalid Date") {
              toast.error("Invalid end date.", {
                toastId: "invalid-e-date",
              });
              setStates({ endDate: new Date() });
              return;
            }

            setStates({
              response: false,
              pdfData: [],
              eLoading: true,
              excelBtnActive: false,
              pdfBtnActive: true,
            });
            let res = await handleGetCustomerStatus("pdf");
          }}
          disabled={states.eLoading}
        >
          {states.eLoading && states.pdfBtnActive ? (
            <React.Fragment>
              <CircularProgress
                style={{ height: 25, width: 25 }}
                variant="determinate"
                value={state.reportResCount}
              />{" "}
              &nbsp;
              <span style={{ color: "#305698", fontWeight: "bold" }}>
                {state.reportResCount == 0 ? (
                  <div class="snippet">
                    <div class="stage">
                      <div class="dot-typing-e"></div>
                    </div>
                  </div>
                ) : (
                  `${state.reportResCount}%`
                )}
              </span>
            </React.Fragment>
          ) : (
            t("Export as pdf")
          )}
        </Button>
        {Object.keys(states.pdfData).length > 0 && states?.pdfBtnActive && (
          <PDFDownloadLink
            style={{ display: "none" }}
            document={
              <MemberRewardsActivityPDF
                states={states}
                date={
                  moment(moment(states?.startDate).format("MM/DD/YYYY")).isSame(
                    moment(states?.endDate).format("MM/DD/YYYY")
                  )
                    ? `Date : ${moment(states?.startDate).format("MM/DD/YYYY")}`
                    : `Date : ${moment(states?.startDate).format(
                      "MM/DD/YYYY"
                    )} to ${moment(states?.endDate).format("MM/DD/YYYY")}`
                }
                setStates={setStates}
              />
            }
            fileName={
              `${page.replace(/ /g, "")}` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A")
            }
          >
            <button id="download-pdf"></button>
          </PDFDownloadLink>
        )}
      </div>
    </div>
  );
}
